import { AxiosError } from 'axios';
import { useMutation, UseMutationOptions, UseMutationResult } from 'react-query';
import { bureauPlatformApi } from '@/utils/api';

export interface CreatePaymentOrderRequest {
  amount: number;
  currency: string;
}

export interface PaymentOrderResponse {
  orderId: string;
  paymentId: string;
  amount: number;
  currency: string;
  status: 'PENDING' | 'SUCCESS' | 'FAILED';
  createdAt: string;
  paymentSessionId: string;
}

const useCreatePaymentOrder = (
  options?: UseMutationOptions<PaymentOrderResponse, AxiosError, CreatePaymentOrderRequest>,
): UseMutationResult<PaymentOrderResponse, AxiosError, CreatePaymentOrderRequest> => {
  return useMutation(createPaymentOrder, options);
};

const createPaymentOrder = async (data: CreatePaymentOrderRequest): Promise<PaymentOrderResponse> => {
  const { data: response } = await bureauPlatformApi.post<PaymentOrderResponse>('/v1/payments/orders', data);
  return response;
};

export default useCreatePaymentOrder;
